let id = 0
function newId () {
	return id++
}

export function resetDefaultId () {
	id = 0
}

export default class Row {
	#id

	get id () {
		return this.#id
	}

	#idToValueMap

	get data () {
		return this.#idToValueMap
	}

	constructor (idToValueMap, id) {
		this.#id = id != null ? id : newId()
		this.#idToValueMap = { ...idToValueMap }
	}

	// /**
	//  * @deprecated
	//  * @param {import("./common").Context} ctx
	//  * @param {number} offsetTop
	//  * @param {number} offsetLeft
	//  * @param {number} height
	//  * @param {import("./column").default[]} fixedCols
	//  * @param {import("./column").default[]} cols
	//  */
	// render (ctx, { offsetTop, offsetLeft, height, fixedCols, cols, rowIndex, currentCellInfo, isLastRow }) {
	// 	// 固定列ではないセルを先に描画する(固定列と被る分を固定列の描画で上書きするため)
	// 	this.renderCells(ctx, { offsetTop, offsetLeft, height, fixedCols, cols, rowIndex, currentCellInfo, isLastRow })
	// 	this.renderFixedCells(ctx, { offsetTop, offsetLeft, height, fixedCols, cols, rowIndex, currentCellInfo, isLastRow })
	// }

	/**
	 * 固定列の描画
	 * @param {import("./common").Context} ctx
	 * @param {object} param
	 */
	renderFixedCells (ctx, { offsetTop, height, fixedCols, currentCellInfo, rowIndex, isLastRow, cellInfos }) {
		const isCurrentRow = currentCellInfo ? rowIndex === currentCellInfo.rowIndex : false
		let fixeColOffsetLeft = 0
		const {
			selectBgColor,
			bgColor
		} = ctx.gridStyle
		fixedCols.forEach(col => {
			const value = this.#idToValueMap[col.options.id]
			col.renderCell(ctx, {
				offsetTop,
				offsetLeft: fixeColOffsetLeft,
				height,
				value: value,
				bgColor: (isCurrentRow && currentCellInfo.col.id === col.id) ? selectBgColor : bgColor,
				isCurrentCell: isCurrentRow && currentCellInfo.col.id === col.id,
				// color,
				rowIndex,
				cellInfo: cellInfos[col.id]
			})
			if (isLastRow) col.flush(ctx)
			fixeColOffsetLeft += col.actualWidth
		})
	}

	/**
	 * 固定でない列の描画
	 * @param {*} ctx
	 * @param {*} param1
	 */
	renderCells (ctx, { offsetTop, offsetLeft, height, fixedCols, cols, currentCellInfo, rowIndex, isLastRow, cellInfos }) {
		const isCurrentRow = currentCellInfo ? rowIndex === currentCellInfo.rowIndex : false
		const totalFixeCollWidth = fixedCols.reduce((totalWidth, col) => {
			return totalWidth + col.actualWidth
		}, 0)
		const {
			selectBgColor,
			bgColor
		} = ctx.gridStyle

		offsetLeft = totalFixeCollWidth + offsetLeft
		cols.forEach(col => {
			const value = this.#idToValueMap[col.options.id]
			const isCurrentCell = isCurrentRow && currentCellInfo.col.id === col.id
			const isUnmodifiable = col.options.unmodifiableRule(this.#idToValueMap)

			col.renderCell(ctx, {
				offsetTop,
				offsetLeft,
				height,
				value: value,
				// color,
				bgColor: isCurrentCell ? selectBgColor : bgColor,
				isCurrentCell,
				rowIndex,
				cellInfo: cellInfos[col.id],
				isUnmodifiable
			})

			offsetLeft += col.actualWidth
			if (isLastRow) col.flush(ctx)
		})
	}
}

/**
 * 外に見せるRowオブジェクト
 */
export class PublicRow {
	#row
	#grid

	get id () {
		return this.#row.id
	}

	get index () {
		return this.#grid.rows.findIndex(row => row.id === this.id)
	}

	get data () {
		return { ...this.#row.data }
	}

	get isSelected () {
		if (!this.#grid.currentCellInfo) return false
		return this.#grid.currentCellInfo.rowId === this.#row.id
	}

	constructor (grid, row) {
		this.#grid = grid
		this.#row = row
	}

	getCellByColId (colId) {
		return this.#grid.getCell(this.index, colId)
	}

	delete () {
		this.#grid.deleteRowById(this.#row.id)
	}
}
